<template>
    <div class="app-container pageallocations">
        <el-row class="toprow is-text-align-right">
            <el-select
                v-model="activeAllocationId"
                placeholder="Select"
                style="width: 300px"
            >
                <el-option
                    v-for="allocation in allocations"
                    :key="'liv' + allocation.id"
                    :label="
                        allocation.annee +
                            '/' +
                            (parseInt(allocation.annee) + 1).toString() +
                            ' - ' +
                            etats[allocation.etat] +
                            ' (' +
                            allocation.max +
                            ' bout.)'
                    "
                    :value="allocation.id"
                />
            </el-select>
            <el-tooltip content="Options allocation">
                <el-link
                    type="success"
                    size="small"
                    icon="el-icon-edit"
                    @click="editAllocation()"
                />
            </el-tooltip>
            <el-tooltip content="Nouvelle allocation">
                <el-link
                    type="success"
                    size="small"
                    icon="el-icon-plus"
                    @click="createAllocation()"
                />
            </el-tooltip>
        </el-row>
        <el-collapse v-model="activeEtat" accordion @change="usersList=[]">
            <el-collapse-item
                v-for="(etat, etatindex) in paniersetats"
                :key="'tableau' + etatindex"
                :title="' Commandes ' + etat +
                ' (nb: ' + lespaniers(etatindex).length +
                ', total ttc: ' + lespanierstotal(etatindex) +')' "
                :name="etatindex"

            >
                <el-table
                    v-loading="paniersloading"

                    :data="lespaniers(etatindex).filter(data => !search[etatindex] || data.user.toLowerCase().includes(search[etatindex].toLowerCase()))"
                    border
                    fit
                    highlight-current-row
                    style="width: 100%"
                >
                    <el-table-column align="left" label="Client" prop="slug" width="250">
                        <template slot="header" slot-scope="scope">
                            <el-input
                                v-model="search[etatindex]"
                                size="mini"
                                :placeholder="scope.column.label"
                                clearable
                            />
                            <input type="checkbox" @change="selectUsers($event,etatindex)">
                            <el-button
                                :disabled="usersList.length===0"
                                type="primary"
                                size="small"
                                icon="el-icon-message"
                                @click="dialogMessageUsersList = true"
                            >
                                Message
                            </el-button>
                        </template>
                        <template slot-scope="scope">
                            <input type="checkbox" :value="scope.row.user_id" v-model="usersList">
                            <span>&nbsp;{{ scope.row.user }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="left"
                        label="nb. cols"
                        width="150"
                        prop="nbcols"
                    >
                        <template slot-scope="scope">
                            <span>{{ scope.row.nbbouteilles }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="left"
                        label="Prix total TTC"
                        width="250"
                        prop="nbcols"
                    >
                        <template slot-scope="scope">
                            <span>{{ scope.row.totalttc }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" label="état" prop="etat">
                        <template slot-scope="scope">
                            <span>{{ paniersetat[scope.row.etat] }}
                                <span :style="isOlderThan30Days(scope.row.updated_at) ? 'color: red; font-weight: 800;' : ''">
                                 {{ scope.row.updated_at | formatDate }}
                                </span>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="edit" width="50">
                        <template slot-scope="scope">
                            <el-tooltip
                                :content="
                                    'Voir/éditer Allocation de ' + scope.row.user
                                "
                            >
                                <el-link
                                    type="success"
                                    size="small"
                                    icon="el-eye-open"
                                    @click="editPanier(scope.row.user_id)"
                                >
                                    <svg-icon icon-class="eye-open" />
                                </el-link>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </el-collapse-item>
        </el-collapse>
        <allocation
            :isvisible="dialogAllocationVisible"
            :allocation="activeAllocation"
            :parent="this"
        />


        <!-- DIALOG dialogMessageUsersList -->
        <el-dialog
            title="MAIL ALLOCATAIRES"
            :visible.sync="dialogMessageUsersList"
            :modal-append-to-body="true"
            :append-to-body="true"
            v-loading="inviterloading"
        >
            <div class="form-container">
                Envoyer un email aux allocataire sélectionnés ({{ usersList.length }} dest.)<br />
                (pour faire un test envoyé à vous même, écrivez "test" en sujet)<br />
                <hr />
                <el-form ref="MessageForm" style="max-width: 600px;">
                    <el-form-item label="Sujet" prop="sujet">
                        <el-input
                            type="text"
                            v-model="sujetUsersList"
                        />
                    </el-form-item>
                    <el-form-item label="Message" prop="message">
                        <el-input
                            type="textarea"
                            :rows="10"
                            v-model="messUsersList"
                        />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogMessageUsersList = false">
                        Annuler
                    </el-button>
                    <el-button type="primary" @click="sendMessageUsersList()">
                        Envoyer
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Resource from "@/api/resource";
const allocationResource = new Resource("allocations");
const panierResource = new Resource("paniers");
import allocation from "@/components/Allocation";
import moment from "moment";
const userResource = new Resource("users");
import { mapState } from "vuex";


export default {
    name: "Allocations",
    components: {
        allocation
    },
    data() {
        return {
            usersList: [],
            messUsersList: '',
            sujetUsersList: '',
            dialogMessageUsersList: false,
            inviterloading: false,

            loading: false,
            //activeEtat: 'avalider',
            activeEtat: null,
            paniersloading: false,
            paniers: null,
            allocations: null,
            dialogAllocationVisible: false,
            activeAllocation: {},
            activeAllocationId: null,
            etats: {
                encours: "En cours",
                finalisee: "Finalisée",
                attente: "En attente"
            },
            paniersetat: {
                encours: "En cours",
                valided: "Validée",
                payed: "Payée",
                livred: "Livrée"
            },
            paniersetats: {
                avalider: "À Valider",
                valided: "Validées",
                payed: "Payées",
                livred: "Livrées",
                encours: "En cours"
            },
            search: [
                'avalider',
                'valided',
                'payed',
                'livred',
                'encours'
            ],


        };
    },
    created() {},
    activated() {
        // console.log("aaaaaaactivated");
        this.getAllocations();
    },
    watch: {
        activeAllocationId(val) {
            if (val && this.allocations) {
                this.activeAllocation = this.allocations.find(
                    allocation => allocation.id === val
                );
                console.log("cherche paniers ALLOCATION:");
                console.log(this.activeAllocationId);
                console.log(this.activeAllocation);

                this.getPaniers(val);
            }
        }
    },
    computed: {
        ...mapState({
            id: state => state.user.id
        })
    },
    methods: {
          isOlderThan30Days(date) {
    const dateObj = new Date(date);
    const today = new Date();
    const diffTime = today - dateObj;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);
    return diffDays > 30;
  },
        sendMessageUsersList() {
            console.log("sendMessageUserList");
            if (this.messUsersList && this.sujetUsersList ) {
                this.inviterloading = true;
                userResource
                    .update(this.id, {
                        messUsersList: this.messUsersList,
                        sujetUsersList: this.sujetUsersList,
                        usersList: this.usersList
                    })
                    .then(response => {
                        console.log(response);
                        let messageRetour = response['message'] ? response['message'] : '';
                        this.$message({
                            message:
                                messageRetour,
                            type: "success",
                            duration: 5 * 1000
                        });
                        this.inviterloading = false;
                        this.dialogMessageUsersList = false;
                        this.messUsersList = "";
                        this.sujetUsersList = "";
                    })
                    .catch(error => {
                        console.log(error);
                        this.$message({
                            message: "Erreur lors de l’envoi à tous les Allocataires",
                            type: "warning",
                            duration: 5 * 1000
                        });
                        this.inviterloading = false;
                    });
            } else{
                this.$message({
                    message: "Le message est vide",
                    type: "warning",
                    duration: 5 * 1000
                });
                this.inviterloading = false;

            }
        },

        selectUsers(ev,etatindex){
            console.log(ev.srcElement.checked);
            console.log(ev,etatindex);
            if(ev.srcElement.checked){
                this.usersList = this.lespaniers(etatindex).map((panier) => panier.user_id)
            } else {
                this.usersList = [];
            }
        },
        lespaniers(etat) {
            if (!this.paniers) {
                return [];
            }
            return this.paniers.filter(panier => panier.etat === etat);
        },
        lespanierstotal(etat) {
            if (!this.paniers) {
                0;
            }
            var total = 0;
            this.paniers.filter(panier => panier.etat === etat).map((panier) => {
                total += panier.totalttc
                return total
            });
            return Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(total);
        },
        editPanier(user_id) {
            console.log("editPanier user" + user_id);
            this.$router.push("/allocataires/edit/" + user_id + "#allocations");
        },
        createAllocation() {
            var annee = moment().format("YYYY");
            console.log(annee);
            this.activeAllocation = {
                annee: annee,
                etat: "attente",
                max: 12
            };
            this.dialogAllocationVisible = true;
        },
        editAllocation() {
            console.log("editAllocation");
            this.dialogAllocationVisible = true;
        },
        async getAllocations() {
            console.log("getAllocations");
            this.activeAllocation = null;
            this.activeAllocationId = null;
            this.loading = true;
            const { data } = await allocationResource.list({});
            this.allocations = data;
            this.activeAllocation = data[0];
            this.activeAllocationId = data[0].id;
            this.loading = false;
            console.log(this.allocations);
        },
        async getPaniers(allocation_id) {
            console.log("getPaniers");
            this.paniersloading = true;
            const { data } = await panierResource.list({'allocation_id': allocation_id, 'noadmins': 1});
            this.paniers = data;
            this.paniersloading = false;
            console.log("ALLOCATIONID::");
            console.log(allocation_id);
            console.log("PANIERS::");
            console.log(this.paniers);
        },
        callbackAllocation(reload, allocation) {
            if (reload) {
                this.getAllocations();
            }
            if (allocation) {
                Object.assign(this.activeAllocation, allocation);
            }
        }
    }
};
</script>
